<div class="hint-icon" [class.has-pulse]="hasPulse" (click)="show()">?</div>
<ng-container *ngIf="showFrame">
  <div class="hint-frame-bg" (click)="close()" @opacityInOut></div>
  <div class="hint-frame" @scaleInOut>
    <i class="app-ico-mask app-ico-mask__x" (click)="close()"></i>
    <iframe #iframe
      [src]="frameUrl"
      [height]="frameHeight"
      width="100%"
      allowfullscreen 
      frameborder="0">
    </iframe>
    <div class="hint-frame__loader" *ngIf="loader" @opacityInOut>
      <div class="round-loader is-trans"></div>
    </div>
    <div class="hint-frame__bottom-area"></div>
  </div>
</ng-container>